<template>
    <div>
        <h1>Stats Appels Entrant</h1>
        <p><b>Fichier CDR provenant d'Atlas au format csv</b></p>
        <div>
            <input id="file" ref="file" size="small" type="file" @change="handleFileUpload"/>
            <el-button type="success" v-if="!isFile" disabled>Calcul de stats</el-button>
            <el-button type="success" v-else v-on:click="submitUpload">Calcul de stats</el-button>
        </div>
        
        <div class="statistiques">
            <h4>Appels entrants : {{appelsE}}</h4>
            <h4>Appels reçus : {{appelsR}}</h4>
            <h4>Appels non-reçus : {{appelsNR}}</h4>
            <h4>Appels pris au cabinet : {{appelsPAC}}</h4>
            <h4>Appels transférés : {{appelsT}}</h4>
            <h4>Appels non-transférés : {{appelsNT}}</h4>
        </div>
        <div>
            <el-button type="success" disabled v-if="!isResult" icon="el-icon-message" circle ></el-button>
            <el-button type="success" v-else icon="el-icon-message" circle ></el-button>
        </div>
    </div>
</template>
<script>
import scriptStats from "../../../../script/script_stats.js"
import { Loading } from 'element-ui';
function initValue(){
    return {
        appelsE:0,
        appelsR:0,
        appelsNR:0,
        appelsPAC:0,
        appelsT:0,
        appelsNT:0,
        appelsS:0,
        file: '',
        isFile: false,
        isResult: false
    }
}
export default {
  watch: {
  },
  props: {
  },
  data () {
    return initValue()
  },
  created () {
  },
  methods: {
        getArrayCSV: scriptStats.getArrayCSV,
        resetData(){
            this.appelsE=0
            this.appelsR=0
            this.appelsNR=0
            this.appelsPAC=0
            this.appelsT=0
            this.appelsNT=0
            this.appelsS=0
            this.isResult = false
        },
        async submitUpload() {
            this.resetData()
            // let loadingInstance1 = Loading.service({ fullscreen: true })
            var res = await this.getArrayCSV(this.file)
            if(res.length){
                this.isResult = true
                for(var key in res){
                    //Traitement

                    //1) Different de 05 et direction entrant
                    if((res[key][1]!="0564132197")){
                        this.appelsE++
                    }


                    
                    //2) Different de 05 et direction entrant et durée different de '-'
                    if((res[key][1]!="0564132197")&&(res[key][3]=="Entrant")&&(res[key][2]!="-")){
                        this.appelsR++
                    }

                    //2) Different de 05 et direction entrant et durée different de '-'
                    if((res[key][1]=="0564132197")&&(res[key][2]!="-")){
                        this.appelsT++
                    }
                    
                    //4-inter) interlocuteur egale 05
                    if(res[key][1]=="0564132197"){
                        this.appelsS++
                    }
                }
                this.appelsNR = this.appelsE - this.appelsR

                this.appelsNT=this.appelsS-this.appelsT

                this.appelsPAC= this.appelsR-this.appelsNT-this.appelsT

            }
            
        },
        handleFileUpload(){
            this.file = this.$refs.file.files[0]
            this.isFile = true
		},
  },

}
</script>

<style>

</style>